import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCafeFeatured } from "../../api/cafe";
import ContentCardSkeleton from "../contentcards/skeleton/ContentCardSkeleton";
import ContentCard from "../contentcards/ContentCard";
import CategoryContentPreview from "../sections/CategoryContentPreview";
import { Media } from "../../compilers/media";

type FeaturedCafeContentTypes = {
  title: string;
  subtitle?: string;
  smallTitle?: boolean;
  linkTitle: string;
  link: string;
  category?: string;
};

const FeaturedCafeContent: React.FC<FeaturedCafeContentTypes> = ({
  title,
  subtitle,
  smallTitle,
  linkTitle,
  link,
  category = "News",
}) => {
  const { i18n, ready } = useTranslation();
  const [cafeContent, setCafeContent] = useState<Media[]>([]);

  useEffect(() => {
    if (ready) {
      //console.log(category);
      getCafeFeatured(i18n.language, category).then((response: Media[]) => {
        setCafeContent(response);
      });
    }
  }, [i18n.language, ready, category]);

  const getContent = () => {
    if (!cafeContent || cafeContent.length < 1) {
      return [
        <ContentCardSkeleton key={0} />,
        <ContentCardSkeleton key={1} />,
        <ContentCardSkeleton key={2} />,
        <ContentCardSkeleton key={3} />,
      ];
    }
    return cafeContent.map((item) => {
      item.data.bluePillText = item.data.type;
      return <ContentCard key={item.id} media={item} section_type="cafe" />;
    });
  };

  return (
    <CategoryContentPreview
      title={title}
      subtitle={subtitle}
      smallTitle={smallTitle}
      linkTitle={linkTitle}
      link={link}
    >
      {getContent()}
    </CategoryContentPreview>
  );
};

export default FeaturedCafeContent;
